import QueryString from "qs"
import http from "../01_axios"
import {
  apiCreateAssociation,
  apiDeleteAssociation,
  apiGetAssociationChildList,
  apiGetAssociationDetail,
  apiGetAssociationNameList,
  apiUpdateAssociation,
  apiGetRequestApproval,
  apiApproveRequest,
  apiRejectRequest,
  apiGetMyAssociationList,
  apiCreateAssociationAdmin,
  apiGetAssociationListNoAuthor,
  apiGetListMemberByAssociation,
} from "./urls"

const getListMemberByAssociation = params =>
  http.get(apiGetListMemberByAssociation, { params })

const getAssociationNameList = params =>
  http.get(`${apiGetAssociationNameList}?` + QueryString.stringify(params))

const getAssociationListNoAuthor = params =>
  http.get(`${apiGetAssociationListNoAuthor}?` + QueryString.stringify(params))

const getAssociationChildList = params =>
  http.get(`${apiGetAssociationChildList}?` + QueryString.stringify(params))

const updateAssociation = body => http.post(apiUpdateAssociation, body)
const deleteAssociation = body => http.post(apiDeleteAssociation, body)
const createAssociation = body => http.post(apiCreateAssociation, body)
const createAssociationAdmin = body =>
  http.post(apiCreateAssociationAdmin, body)
const approveRequest = associationId =>
  http.post(apiApproveRequest, [associationId])
// const rejectRequest = associationId =>
//   http.post(apiRejectRequest, [associationId])
const rejectRequest = body => http.post(apiRejectRequest, body)

const getAssociationDetail = params =>
  http.get(apiGetAssociationDetail, { params })
const getRequestApproval = params => http.get(apiGetRequestApproval, { params })
const getMyAssociationList = params =>
  http.get(apiGetMyAssociationList, { params })

const AssociationService = {
  createAssociation,
  getAssociationDetail,
  getAssociationNameList,
  getAssociationChildList,
  updateAssociation,
  deleteAssociation,
  getRequestApproval,
  approveRequest,
  rejectRequest,
  getMyAssociationList,
  createAssociationAdmin,
  getAssociationListNoAuthor,
  getListMemberByAssociation,
}
export default AssociationService
